import { formatDate } from '@angular/common';
import { Component, input, OnChanges, output, SimpleChanges } from '@angular/core';
import { Modal } from 'flowbite';
import { ConversationMessage } from 'src/app/models';
import { LiteralService, UtilsService } from 'src/app/services';
import { TranslateService } from '@ngx-translate/core';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-conversation',
  templateUrl: './modal-conversation.component.html',
  styleUrl: './modal-conversation.component.scss',
  standalone: false
})
export class ModalConversationComponent implements OnChanges {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly messages = input<ConversationMessage[]>();
  readonly sendMessage = input<any>();
  readonly receiverName = input<string>();
  readonly action = output<string>();
  readonly close = output<void>();

  public groupedMessagesByDate: any = {};
  public groupedMessagesKeys: any = [];

  public newMessage = '';

  public images = images;

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
    private translateService: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages'] && changes['messages'].currentValue) {
      this.groupedMessagesByDate = {};
      changes['messages'].currentValue.map((message: ConversationMessage) => {
        const dates = Object.keys(this.groupedMessagesByDate);
        const locale = this.translateService.currentLang || 'es';
        const messageDate = this.utilsService.capitalize(formatDate(message.createdAt, 'EEE dd/MM/yyyy', locale));
        if (dates.includes(messageDate)) {
          this.groupedMessagesByDate[messageDate].push(message);
        } else {
          this.groupedMessagesByDate[messageDate] = [message];
        }
      });
      this.groupedMessagesKeys = Object.keys(this.groupedMessagesByDate);
      setTimeout(() => {
        this.scrollToBottom();
      }, 50);
    }
  }

  scrollToBottom() {
    const conversationContainerElement = document.getElementById('conversation-container');
    if (conversationContainerElement) {
      conversationContainerElement.lastElementChild?.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }

  isReceiverMessage(message: ConversationMessage) {
    return message.creatorName === this.receiverName();
  }

  onChangeMessage(event: any) {
    this.newMessage = event.target.value;
  }

  onSendMessage() {
    if (!this.newMessage.trim()) return;
    this.action.emit(this.newMessage);
    this.newMessage = '';
  }

}
